import React from "react";

export default function AlignLines() {
	return (
		<div>
			<div className="line left-1"></div>
			<div className="line left-2"></div>
			<div className="line left-3"></div>
			<div className="line middle"></div>

			<div className="line right-1"></div>
			<div className="line right-2"></div>
			<div className="line right-3"></div>

			<style jsx="true">{`
				.line {
					position: absolute;
					height: 1000vh;
					border: 1px solid red;
					z-index: 100;
				}
				.left-1 {
					left: 150px;
				}

				.left-2 {
					left: 231px;
				}
				.left-end {
					left: 0px;
				}

				.middle {
					left: 800px;
				}
				.right-1 {
					left: 1377px;
				}

				.right-2 {
					left: 1450px;
				}
				.right-3 {
					left: 1600px;
				}
			`}</style>
		</div>
	);
}
